import { has } from 'lodash';

/**
 * Checks if multiple keys are set in objects.
 */
export const hasObjectKeys = <T extends object = Record<string, unknown>>(
  obj: T,
  keys: Array<string | number>
): boolean => !!keys.length && keys.every((k) => has(obj, k));
